module.exports = __webpack_public_path__ + "static/NewLanguage-e49beb73941a04359e90da99e07795e8.png";